import script from "./TipsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TipsView.vue?vue&type=script&setup=true&lang=js"

import "./TipsView.vue?vue&type=style&index=0&id=51116422&lang=css"

const __exports__ = script;

export default __exports__